import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { apiService } from "../constants/ApiService";

export default function useVendorBranch(user, initialVendorId = null) {
  const [venderMaster, setVenderMaster] = useState([]);
  const [branchMaster, setBranchMaster] = useState([]);
  const [loading, setLoading] = useState({ vender: false, branch: false });

  const isSuperAdmin = user?.user_profile?.toLowerCase() === "superadmin";
  const isAdmin = user?.user_profile?.toLowerCase() === "admin";

  const userVendorId = user?.vender_master_id || null;
  const userBranchId = user?.branch_id || null;


  const parseBranchAccess = (str) => {
    if (!str) return [];
    return str
      .split(",")
      .map(s => s.split("-")[0])
      .filter(x => !isNaN(x))
      .map(Number);
  };

  const allotedMultipleBranches = user?.branch_id_and_names
  const accessibleBranchIds = parseBranchAccess(allotedMultipleBranches);
  const hasMultiBranch = accessibleBranchIds.length > 1 || allotedMultipleBranches === "0-All";
  const hasSingleBranch = accessibleBranchIds.length === 1 && allotedMultipleBranches !== "0-All";

  // Fetch vendors (only for superadmin)
  const fetchVendors = useCallback(async (page = 1, limit = 100, search = "") => {
    if (!isSuperAdmin) {
      // For admin/normal users, vendor is fixed
      setVenderMaster(userVendorId ? [{ id: userVendorId, vender_name: "Your Vendor" }] : []);
      return;
    }

    setLoading((prev) => ({ ...prev, vender: true }));
    try {
      const response = await apiService.get(`/api/VenderMaster/all?pageNo=${page}&limit=${limit}&searchKey=${search}`);
      if (response.status) {
        setVenderMaster(response.venderMasterData || []);
        return response.venderMasterData;  // return list
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching vendors");
    } finally {
      setLoading((prev) => ({ ...prev, vender: false }));
    }
  }, [isSuperAdmin, userVendorId]);

  // Fetch branches
// const fetchBranches = useCallback(
//   async (vendorIdParam, page = 1, limit = 10, search = "") => {
//     let vendorId = vendorIdParam;

//     if (isAdmin) vendorId = userVendorId;

//     setLoading((prev) => ({ ...prev, branch: true }));

//     try {
//       let query = `pageNo=${page}&limit=${limit}&searchKey=${search}`;
//       if (vendorId) query += `&filterName=${vendorId}`;

//       const response = await apiService.get(`/api/BranchMaster/all?${query}`);

//         console.log(response,"response.branchMasterData")
//       if (response.status) {

//         // Only SuperAdmin/Admin auto-set branchMaster
//         if (isSuperAdmin || isAdmin) {
//           setBranchMaster(response.branchMasterData || []);
//         }


//         return response.branchMasterData;
//       } else {
//         toast.error(response.message);
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Error fetching branches");
//     } finally {
//       setLoading((prev) => ({ ...prev, branch: false }));
//     }
//   },
//   [isSuperAdmin, isAdmin, userVendorId]
// );

const fetchBranches = useCallback(
  async (vendorIdParam, page = 1, limit = 100, search = "") => {
    let vendorId = vendorIdParam;

    if (isAdmin) vendorId = userVendorId;

    setLoading((prev) => ({ ...prev, branch: true }));

    try {
      let query = `pageNo=${page}&limit=${limit}&searchKey=${search}`;

      if (vendorId) {
        query += `&filterName=${vendorId}`;
      }

      const response = await apiService.get(`/api/BranchMaster/all?${query}`);

      if (response.status) {

        // ALWAYS SET
        setBranchMaster(response.branchMasterData || []);

        return response.branchMasterData || [];
      } else {
        toast.error(response.message);
        return [];
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching branches");
      return [];
    } finally {
      setLoading((prev) => ({ ...prev, branch: false }));
    }
  },
  [isAdmin, userVendorId]
);


  // Auto-load vendors and branches based on role
  useEffect(() => {
    if (isSuperAdmin) {
      fetchVendors();
    } else if (isAdmin) {
      // Vendor fixed, fetch branches
      fetchBranches(userVendorId);
    } else {
      // NORMAL USER BEHAVIOR
      setVenderMaster([{ id: userVendorId, vender_name: "Your Vendor" }]);

      const loadNormalUserBranches = async () => {
        if (hasMultiBranch || hasSingleBranch) {
          // fetch all real branches of this vendor
          const allBranches = await fetchBranches(userVendorId, 1, 9999, "");

          if (!allBranches) return;

          // Filter only branches allowed via branch_id_and_names
          const filtered = allBranches.filter(b =>
            accessibleBranchIds.includes(Number(b.id))
          );

          // If multi-branch → show dropdown
          if (hasMultiBranch) {
            setBranchMaster(filtered);
          }
          // If single branch → auto assign that one
          else if (hasSingleBranch) {
            setBranchMaster([filtered[0]]);
          }
        }
        else {
          // fallback old logic
          setBranchMaster([
            { id: userBranchId, branch_name: "Your Branch" }
          ]);
        }
      };

      loadNormalUserBranches();
    }
  }, [fetchVendors, fetchBranches, isSuperAdmin, isAdmin, userVendorId, userBranchId]);

  return {
    venderMaster,
    branchMaster,
    loading,
    fetchBranches,
    fetchVendors,
    isSuperAdmin,
    isAdmin,
    accessibleBranchIds,
    hasMultiBranch,
    hasSingleBranch
  };
}
